import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGas: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"gas"} maskId="square-filled-radius-0-stroke-1-IconGas"><path fillRule="evenodd" clipRule="evenodd" d="M4 3H16V9H19V17H21V7.70711L18.7929 5.5L19.5 4.79289L22 7.29289V18H18V10H16V20H17V21H3V20H4V3ZM7 9H13V10H7V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconGas;
